import { getAppUrl } from "../appV2/environment/getAppUrl";

export function getSignInLink(
  requestedURL: string,
  email: string,
  options?: { useCognitoMagicLink?: boolean }
): string {
  const appDomain = getAppUrl();
  const verifyPath = options?.useCognitoMagicLink ? "/v2/email-login-link" : "/login/verify";

  const searchParams = new URLSearchParams({
    requestedUrl: requestedURL,
    email,
  });

  return `${appDomain}${verifyPath}?${searchParams}`;
}
